(function () {
    "use strict";

    class InfoModal extends HTMLElement {
        constructor() {
            super();
            this.data = null;
            this.currentIndex = 0;
            this.modalEl = null;
            this._onKeydown = null;
        }

        connectedCallback() {
            const dataScript = this.querySelector("[data-info-modal-data]");
            if (dataScript) {
                try {
                    this.data = JSON.parse(dataScript.textContent);
                } catch (err) {
                    console.error("info-modal: invalid JSON", err);
                    this.data = null;
                }
            }

            const trigger = this.querySelector(".modal-open");
            if (trigger) {
                trigger.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.open();
                });
            }

            if (this.hasAttribute("data-identifier-pop-up")) {
                const params = new URLSearchParams(window.location.search);
                if (params.get("pop_up_on_arrival")) {
                    this.open();
                    history.replaceState({}, document.title, window.location.pathname);
                }
            }
        }

        disconnectedCallback() {
            this._teardown();
        }

        open() {
            if (!this.data || !Array.isArray(this.data.slides) || !this.data.slides.length) return;
            if (this.modalEl) return;

            this.currentIndex = 0;
            this.modalEl = this._buildModal();
            document.body.appendChild(this.modalEl);
            document.body.style.overflow = "hidden";

            requestAnimationFrame(() => {
                this.modalEl.classList.add("is-open");
            });
        }

        close() {
            if (!this.modalEl) return;
            this.modalEl.classList.remove("is-open");
            const el = this.modalEl;
            this._teardown();
            setTimeout(() => {
                if (el.parentNode) el.parentNode.removeChild(el);
            }, 250);
        }

        _teardown() {
            if (this._onKeydown) {
                document.removeEventListener("keydown", this._onKeydown);
                this._onKeydown = null;
            }
            document.body.style.overflow = "";
            this.modalEl = null;
        }

        _buildModal() {
            const slides = this.data.slides;
            const multi = slides.length > 1;

            const overlay = document.createElement("div");
            overlay.className = "info-modal";
            overlay.innerHTML = `
                <div class="info-modal__backdrop" data-close></div>
                ${multi ? `<button type="button" class="info-modal__nav info-modal__nav--prev" data-prev aria-label="Previous">‹</button>` : ""}
                <div class="info-modal__panel" role="dialog" aria-modal="true">
                    <button type="button" class="info-modal__close" data-close aria-label="Close">×</button>
                    <div class="info-modal__body" data-body></div>
                    ${multi ? `<div class="info-modal__dots" data-dots></div>` : ""}
                </div>
                ${multi ? `<button type="button" class="info-modal__nav info-modal__nav--next" data-next aria-label="Next">›</button>` : ""}
            `;

            overlay.querySelectorAll("[data-close]").forEach((el) => {
                el.addEventListener("click", () => this.close());
            });

            if (multi) {
                overlay.querySelector("[data-prev]").addEventListener("click", () => this._go(this.currentIndex - 1));
                overlay.querySelector("[data-next]").addEventListener("click", () => this._go(this.currentIndex + 1));
            }

            this._onKeydown = (e) => {
                if (e.key === "Escape") this.close();
                else if (multi && e.key === "ArrowLeft") this._go(this.currentIndex - 1);
                else if (multi && e.key === "ArrowRight") this._go(this.currentIndex + 1);
            };
            document.addEventListener("keydown", this._onKeydown);

            this._renderSlide(overlay);
            this._renderDots(overlay);

            return overlay;
        }

        _go(nextIndex) {
            const total = this.data.slides.length;
            this.currentIndex = ((nextIndex % total) + total) % total;
            this._renderSlide(this.modalEl);
            this._renderDots(this.modalEl);
        }

        _renderSlide(root) {
            const slide = this.data.slides[this.currentIndex];
            const body = root.querySelector("[data-body]");
            const hasImage = typeof slide.image === "string" && slide.image.trim() !== "";

            body.innerHTML = "";

            if (hasImage) {
                const img = document.createElement("img");
                img.className = "info-modal__image";
                img.src = slide.image;
                img.alt = "";
                body.appendChild(img);
            }

            if (slide.title) {
                const title = document.createElement("h2");
                title.className = "info-modal__title";
                title.textContent = slide.title;
                body.appendChild(title);
            }

            if (slide.text) {
                const text = document.createElement("p");
                text.className = "info-modal__text";
                text.textContent = slide.text;
                body.appendChild(text);
            }
        }

        _renderDots(root) {
            const dotsEl = root.querySelector("[data-dots]");
            if (!dotsEl) return;
            const total = this.data.slides.length;
            dotsEl.innerHTML = "";
            for (let i = 0; i < total; i++) {
                const dot = document.createElement("button");
                dot.type = "button";
                dot.className = "info-modal__dot" + (i === this.currentIndex ? " is-active" : "");
                dot.setAttribute("aria-label", "Slide " + (i + 1));
                dot.addEventListener("click", () => this._go(i));
                dotsEl.appendChild(dot);
            }
        }
    }

    if (!customElements.get("info-modal")) {
        customElements.define("info-modal", InfoModal);
    }
})();
